import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import api, { ApiResponse } from "../../services/api";
import Cookies from "js-cookie";
import { verifyadminToken } from "../../utils/auth";

interface LoginResponse {
  success: boolean;
  token: string;
  data: {
    id: string;
    email: string;
  };
}

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
     const [isTokenValid, setIsTokenValid] = useState<boolean | null>(null);

  useEffect(() => {
    verifyadminToken(setIsTokenValid).then((isValid) => {
      if (isValid) {
        window.hasVerifiedToken = true;
        navigate("/admin");
      }
    });
  }, [navigate]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await api.post<LoginResponse>("/admin/login", {
        email,
        password,
      },
      { withCredentials: true });

      if (data.success) {
        Cookies.set("token", data.token)
         window.hasVerifiedToken = true; 
        toast.success("Login successful!");
        navigate("/admin");
      } else {
        toast.error("Login failed");
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 401) {
          toast.error("Invalid email or password");
        } else if (error.response.status === 400) {
          toast.error(error.response.data?.error || "Invalid request");
        } else {
          toast.error("Login failed. Please try again.");
        }
      } else if (error.request) {
        toast.error("Network error. Please check your connection.");
      } else {
        toast.error("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md">
        <h1 className="text-center mb-8 text-blue-600 text-2xl font-semibold">
          Admin Login
        </h1>

        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="mb-6">
            <label
              htmlFor="email"
              className="block mb-2 text-gray-700 text-sm font-medium"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full p-3 border border-gray-300 rounded-md text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Password */}
          <div className="mb-8">
            <label
              htmlFor="password"
              className="block mb-2 text-gray-700 text-sm font-medium"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full p-3 border border-gray-300 rounded-md text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`w-full p-3 rounded-md text-lg font-medium transition-all duration-150 
              ${
                loading
                  ? "bg-blue-600 text-white opacity-70 cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-[#0c2b4b] hover:shadow-[0_0_12px_rgba(0,123,255,0.3)] hover:scale-105"
              }`}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* Forgot / OTP Trigger */}
        {/* <div
          className="mt-5 text-blue-700 underline cursor-pointer"
          onClick={() => setShowOtpModal(true)}
        >
          Forgot Password (OTP)?
        </div> */}
      </div>

      {/* OTP Modal */}
      {showOtpModal && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={() => setShowOtpModal(false)}
        >
          <div
            className="bg-white p-6 rounded-lg w-72 text-center relative"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold mb-4">Enter OTP</h3>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full p-2 mb-4 border border-gray-300 rounded-md text-center text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              className="w-full p-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-all duration-150"
              onClick={() => {
                toast.success(`OTP entered: ${otp}`);
                setShowOtpModal(false);
              }}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
